import { BaseError } from './BaseError.js';
/**
 * Error thrown for general runtime failures.
 * Used for configuration errors, integration failures, operation errors,
 * database errors, and any other runtime issues.
 */
export class RuntimeError extends BaseError {
    context;
    name = 'RuntimeError';
    constructor(message, context, cause) {
        super(message, cause);
        this.context = context;
    }
}
//# sourceMappingURL=RuntimeError.js.map